import { render, staticRenderFns } from "./vendor-aggrement-create.vue?vue&type=template&id=39b8ea2d&"
import script from "./vendor-aggrement-create.vue?vue&type=script&lang=js&"
export * from "./vendor-aggrement-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports